"use client";
import DemoPage from "@/modules/departments/pages/DemoPage";

export default function Demo() {
  return <DemoPage />;
}
